(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hs-clean"] && !Shopify.designMode) return;
  try {
    
(() => {
  const instances = new Map();
  function init(root) {
    root.querySelectorAll('.hs-clean').forEach(section => {
      if (instances.has(section)) return;
      const cards = Array.from(section.querySelectorAll('[data-clean]'));
      const image = section.querySelector('[data-clean-img]');
      const view = section.querySelector('[data-clean-view]');
      const caption = section.querySelector('[data-clean-caption]');
      if (!image || cards.length < 2) return;
      let index = 0;
      let timer;
      let visible = false;
      let paused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'hs-clean__autoplay';
      function label() {
        toggle.textContent = paused ? '▶' : 'Ⅱ';
        toggle.setAttribute('aria-label', paused ? 'Play image rotation' : 'Pause image rotation');
      }
      function show(i) {
        index = i;
        const source = cards[index];
        image.removeAttribute('srcset');
        image.src = source.dataset.img;
        image.alt = source.dataset.caption || '';
        if (source.dataset.grad) view.style.background = source.dataset.grad;
        if (caption) caption.textContent = source.dataset.caption || '';
        cards.forEach((card, n) => {
          const active = n === index;
          card.classList.toggle('is-on', active);
          const cue = card.querySelector('[data-clean-cue]');
          if (cue) cue.textContent = active ? card.dataset.cueOn : card.dataset.cueOff;
        });
      }
      function schedule() {
        clearInterval(timer);
        if (!paused && visible && !document.hidden) timer = setInterval(() => show((index + 1) % cards.length), 3000);
      }
      cards.forEach((card, i) => {
        const preload = new Image();
        preload.src = card.dataset.img;
        card.addEventListener('click', () => { show(i); schedule(); });
      });
      toggle.addEventListener('click', () => { paused = !paused; label(); schedule(); });
      view.parentElement.append(toggle);
      label();
      show(0);
      const observer = new IntersectionObserver(entries => {
        visible = entries[0].isIntersecting;
        schedule();
      }, { threshold: 0.25 });
      observer.observe(view);
      document.addEventListener('visibilitychange', schedule);
      instances.set(section, () => { clearInterval(timer); observer.disconnect(); document.removeEventListener('visibilitychange', schedule); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('.hs-clean').forEach(section => { instances.get(section)?.(); instances.delete(section); });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
